import $ from 'jquery';
import autosize from 'autosize';

/**
 * Applies the correct class names to the field.
 *
 * @param e - The event object
 */
function setState(e={}) {
    const field = $(this);

    // Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
    // problem with the "keydown" event in that the key value is added to the field after the event has been
    // called. This means the value of the field returned will be the previous value. The timeout ensures that
    // the input happens before the value is checked.
    setTimeout(() => {

        // Enhance the file input by outputting information about the selected file
        if (field.is('input[type="file"]')) {
            const div = field.siblings('div');
            let fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = `${this.files.length} files selected`;
            } else {
                fileName = this.value.split('\\').pop();
            }

            div.html(fileName);
        }

        field.closest('[sw-float-label]')

            // Set the field type as a class to the float label wrapper
            .addClass('-type-' + field.prop('tagName').toLowerCase())

            // Is the element in focus?
            .toggleClass('is-focused', (e.type == 'focus') || field.is(':focus'))

            // Check if the fields value is an empty string. This works for select options that have an empty
            // value. This can be exploited by creating an empty option, disabling it and setting it as the
            // default.
            .toggleClass('is-filled', !!field.val())

            // Only apply if browser supports field validation
            .toggleClass('is-invalid', field[0].validity && !field[0].validity.valid)

            // Specifically for textarea's. This is useful so that the label can be hidden when the content is
            // scrolled, so that the label and the fields text don't overlap and look ugly.
            .toggleClass('is-scrolled', field.scrollTop() > 0);
    });
}

/**
 * Adds float label behaviour to marked fields.
 *
 * @param context
 */
export default function floatLabelDirective(context=document.body) {

    $(context).find('[sw-float-label]')
        .find('input, select, textarea')
            .on('focus blur change keyup keydown scroll', setState)
            .each(setState);
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/float-label.js